module.exports = __webpack_public_path__ + "assets/img/2_818.a78f27d8.jpg";